import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MyBookingPassengerPresModule } from '../presenter/my-booking-passenger-pres.module';
import { MyBookingPassengerContComponent } from './my-booking-passenger-cont.component';

@NgModule({
  declarations: [MyBookingPassengerContComponent],
  imports: [CommonModule, MyBookingPassengerPresModule],
  exports: [MyBookingPassengerContComponent],
})
export class MyBookingPassengerContModule {}
